
interface Props {
  header: string;
  link: string;
  linkText: string;
}

const BioBlock = (props: Props) => {
  return (
    <div className="mt-4 flex items-center">
      <div className="rounded bg-red-900 w-8 h-8 mr-4" />
      <div className="flex-1">
        <p className="text-lg font-semibold">{props.header}</p>
        <p className="text-sm">
          <a
            className="text-red-800 underline"
            href={props.link}
          >
            {props.linkText}
          </a>
        </p>
      </div>
    </div>
  );
};

export default BioBlock;